import * as React from 'react';
import { graphql } from 'gatsby';
import MainLayout from '../containers/MainLayout.container';
import { useLanguage } from '../locales';
import { Wrapper, Title } from '../styles/tags.styles';
import SEO from '../components/SEO/SEO';
import BlogsList from '../components/Blogs/BlogsList';
import { useLocation } from '@reach/router';
const TagsTemplate = (props) => {
  const { translation, lang } = useLanguage();
  const { tags } = props.data;
  const { pathname } = useLocation();
  return (
    <>
      <SEO
        title={`tag ${props.pageContext.tag}`}
        lang={lang}
        pathname={pathname}
      />
      <MainLayout>
        <Wrapper>
          <Title>
            {translation.tags.specificTagTitle(props.pageContext.tag)}
          </Title>
          {tags?.nodes?.length ? <BlogsList blogs={tags.nodes} /> : null}
        </Wrapper>
      </MainLayout>
    </>
  );
};

export const query = graphql`
  query($tag: String!) {
    tags: allContentfulBlogPost(filter: { tags: { eq: $tag } }) {
      nodes {
        contentful_id
        title_en
        title_vi
        category
        first_child_category
        second_child_category
        tags
        author
        slug
        description_en
        description_vi
        image {
          fixed(width: 360, height: 360) {
            width
            height
            src
            srcSet
          }
        }
        author
        updatedAt
        createdAt
      }
    }
  }
`;

export default TagsTemplate;
